var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.isSuperTag)?[_c('i',{staticClass:"far fa-sparkles"}),_vm._v(" \n    ")]:_vm._e(),_vm._v("\n    "+_vm._s(_vm.sanitizedName)+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }